<order-list-tag>
<div class="contents_block table">
  <table class="contents_table">
    <tbody>
      <tr class="column_orders">
        <th class="date sort-cel">お申込日<a class="button_sort-{state.orderby}" onclick={(e)=>toggleOrderby(e)}></a></th>
        <th class="service">サービス名</th>
        <th class="order-id">注文ID / 注文名</th>
        <th class="price">金額（税込）</th>
        <th class="person">担当者</th>
        <th class="status">ステータス</th>
      </tr>
      <tr each={ (order,i) in state.orders }>
        <td><span class="date">{order.ordered_date}</span></td>
        <td>{order.source}</td>
        <td><a class="order-id" onclick={(e)=>detail(e,order)}>{order.id} / {order.name}</a></td>
        <td>{Number(order.price).toLocaleString()}円</td>
        <td if={order.source != 'EDILENT'}>{order.staff}</td>
        <td if={order.source == 'EDILENT'}>{ username(order.staff) }</td>
        <td><span class="{OrderStatus(order.status).class}">{OrderStatus(order.status).text}</span></td>
      </tr>
    </tbody>
  </table><!--/.contents_table-->
</div><!--/.contents_block-->

<editech-hub-pagination-tag pager="{state.pager}" onpager="{(e,page)=>props.updatePage(page)}" if={state.pager.last > 1}></editech-hub-pagination-tag>

<script>
  import di from "dependeny-injection";
  import Status from "@model/status.js";
  export default {
    OrderStatus: Status.order,
    state: {
      orderby: 'descend',
      orders: [],
      limit: null,
      isLoading: true,
      page: 1,
      pager: {page: 1, total: 0, last: 0,  prev: 0, next: 0}
    },
    username(bizid){
      return window.__INITIAL_PROPS__.users[bizid] || '-';
    },
    toggleOrderby(e){
      if (this.state.orderby == 'descend') {
        this.update({orderby: 'ascend'});
        this.props.setOrderBy('asc');
      }else{
        this.update({orderby: 'descend'});
        this.props.setOrderBy('desc');
      }
    },
    detail(e, order) {
      window.open(order.detail_link, `order-${order.id}`);
    },
    onOrderUpdate(data) {
      this.update({
        orders: data.items,
        isLoading: false,
        pager: data,
        page: data.page
      });
      this.props.pagerBinder(data);
    },
    fetchOrder(){
      this.props.MenuApi.request('order', 'fetch', this.props.params)
        .then(data => this.onOrderUpdate(data))
    },
    onBeforeMount(props, state){
      this.props.MenuApi.on('order:search', () => this.fetchOrder());
      this.fetchOrder();
    }
  }
</script>
</order-list-tag>
